import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot,
         RouterStateSnapshot, CanActivateChild } from '@angular/router'
import { Observable } from 'rxjs'

import { AuthService } from './auth.service'

import { AuthGuardService } from './auth-guard.service'

@Injectable({
  providedIn: 'root'
})
export class SupportAdminGuardService implements CanActivate, CanActivateChild {
  constructor(
    public authService: AuthService,
    public authGuard: AuthGuardService) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const returnURL = 'https://www.sportsengine.com'

    return new Observable<boolean>((observer) => {
      this.authService.isSupportAdmin().then((result) => {
        observer.next(result)
        observer.complete()
        if (!result) {
          window.location.href = returnURL
        }
      })
    })
  }

  public canActivateChild(route: ActivatedRouteSnapshot,
                          state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state)
  }
}
